// Authentication hook with Ory support
import { useAuthStore } from '@store';

export const useAuth = () => {
  const {
    user,
    isAuthenticated,
    isLoading,
    error,
    authProvider,
    orySession,
    login,
    register,
    initiateOryLogin,
    initiateOryRegistration,
    handleOryCallback,
    syncOrySession,
    logout,
    getCurrentUser,
    clearError,
    setAssignedSalesperson,
  } = useAuthStore();

  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    authProvider,
    orySession,
    login,
    register,
    initiateOryLogin,
    initiateOryRegistration,
    handleOryCallback,
    syncOrySession,
    logout,
    getCurrentUser,
    clearError,
    setAssignedSalesperson,
  };
};
